/**
 *  Video Manager
	Default className to call video : '.js-call-video'. Can Custom with opts.videos
	Default className for popin-video : '.js-popin-video'. Can Custom with opts.popin
	
	Params (data-attr) for dom element : {
		data-type: 'youtube' || 'vimeo' || 'internal,
		data-video: 'string' // Video ID or URL VIDEO
		data-poster: 'string' // URL Img Poster
		data-auto-play: boolean // Video is autoplaying on show Popin (default 'true')
		data-close-on-ended: boolean // Popin autoclose on video ended (default 'false')
	}
 */
import Plyr from 'plyr';
export default class VideosPopinManager {
	constructor(opts) {

		// DOM
		this.dom = {};
		this.dom.body = document.body;
		this.dom.videos = (opts && opts.videos) ? this.dom.body.querySelectorAll(opts.videos) : this.dom.body.querySelectorAll('.js-call-video');


		// Popin
		this.dom.popin = {};
		this.dom.popin.component = (opts && opts.popin) ? this.dom.body.querySelector(opts.popin) : this.dom.body.querySelector('.js-popin-video');
		this.dom.popin.inner = this.dom.popin.component.querySelector('.js-wrapper-video');
		this.dom.popin.close = this.dom.popin.component.querySelector('.js-close');
		this._paramsPopin = {
			isOpen: false,
		};

		this._bindAll = {
			callClose: this.callClose.bind(this),
			showPopin: this.showPopin.bind(this),
			escapeClose: this.escapeClose.bind(this),
			closeOutside: this.closeOutside.bind(this),
		}

		// Instances
		this.AllVideos = [];
	}

	_unbind() {
		for (let i = 0; i < this.dom.videos.length; i++) {
			const el = this.dom.videos[i];
			el.removeEventListener('click', this._bindAll.showPopin);
		}
		
		if (this.AllVideos.length > 0) 
			this.dom.popin.close.removeEventListener('click', this._bindAll.callClose);
		
		for (let i = 0; i < this.AllVideos.length; i++) {
			const video = this.AllVideos[i];
			delete video.instance;
		}
		this.AllVideos = [];

		window.removeEventListener('keydown', this._bindAll.escapeClose);
		this.dom.popin.component.removeEventListener('click', this._bindAll.closeOutside);
	}

	_bind() {
		// INIT
		for (let i = 0; i < this.dom.videos.length; i++) {
			let el = this.dom.videos[i];
			let id = el.getAttribute('data-video');
			let obj = {
				id: id,
				instance: new VideoPopin(el, this.dom.popin.component, this._bindAll.callClose),
			};
			
			// Store Instances
			this.AllVideos.push(obj);
			el.addEventListener('click', this._bindAll.showPopin);
		}

		if (this.AllVideos.length > 0) {
			this.dom.popin.close.addEventListener('click', this._bindAll.callClose);
		}

		// POPIN
		// Helpers close on Escape / outside click
		window.addEventListener('keydown', this._bindAll.escapeClose);
		this.dom.popin.component.addEventListener('click', this._bindAll.closeOutside);
	}

	escapeClose(evt) {
		if (!this._paramsPopin._isOpen)
			return;
		
		evt = evt || window.event;
		var isEscape = false;
		if ("key" in evt) {
			isEscape = (evt.key === "Escape" || evt.key === "Esc");
		} else {
			isEscape = (evt.keyCode === 27);
		}
		if (isEscape) {
			this.callClose();
		}
	}

	closeOutside(evt) {
		if (!this.dom.popin.inner.contains(evt.target))
			this.callClose();
	}

	/**
	 * Clear and Stop
	 */	
	callClose() {
		this.closePopin();
		this.stopAll();
	}

	stopAll() {
		for (let i = 0; i < this.AllVideos.length; i++) {
			const el = this.AllVideos[i];
			if (typeof el.instance.stopVideo() === "function") { 
				el.stopVideo();
			}
		}
	}

	/**
	 * Popin Switch
	 */	
	showPopin(e, hasBeenEmitted = false) {
        if(hasBeenEmitted != true){
			let flickityParent = closest(e.target, '.flickity-viewport');
			if(flickityParent){
				return;
			}	
		}
		this._paramsPopin.isOpen = true;
		TweenLite.to(this.dom.popin.component, 0.5, {autoAlpha: 1});
		// console.log('showPopin');
	}

	closePopin() {
		this._paramsPopin.isOpen = false;
		TweenLite.to(this.dom.popin.component, 0.5, {autoAlpha: 0});
		// TweenLite.to(this.dom.popin.inner, 0.5, {autoAlpha: 0});

	}
}

// Instance by Video
class VideoPopin {
	constructor(el, popin, callbackEnded) {
		this.callbackEnded = callbackEnded;

		this.firstPlay = true;

		this._params = {
			type: el.getAttribute('data-type'),
			id: el.getAttribute('data-video'),
			poster: el.getAttribute('data-poster'),
			autoPlay: el.getAttribute('data-auto-play') || 'true',
			autoClose: el.getAttribute('data-close-on-ended') || 'false',
			isListenerClickedActive: false
		};

		if (this._checkRequiredAttr() == false)
			return;
		
		// DOM
		this.dom = {};
		this.dom.component = el;
		this.dom.body = document.body;
		this.dom.popin = popin;
		this.dom.wrapper = this.dom.popin.querySelector('.js-wrapper-video');
		this.dom.poster = this.dom.popin.querySelector('.js-poster');
		this.dom.buttonPlay = this.dom.popin.querySelector('.js-play');

		this.dom.component.addEventListener('click', this._loadVideo.bind(this));
	}

	_checkRequiredAttr() {
		if (this._params.id == null){
			console.warn('data-video forget. Video id expected');
			return false;
		}
		
		if (this._params.type == null) {
			console.warn('data-type forget. vimeo or youtube expected');
			return false;
		}

		if (this._params.poster == null) {
			console.warn('data-poster forget. Url img');
			return false;
		}
	}

	/**
	 * Load Video Instance
	 */	
	_loadVideo(e, hasBeenEmitted = false) {
        if(hasBeenEmitted != true){

			let flickityParent = closest(e.target, '.flickity-viewport');
			if(flickityParent){
				return;
			}	
		}

		this._preparePlayer();
        
		// EVENTS Click
		if( this.dom.buttonPlay ) {
			this.dom.buttonPlay.addEventListener('click', () => {
				this._params.isListenerClickedActive = true;
				this._playVideo();
			});
		}

	}

	/**
	 * Prepare Player with dom element player to receive iFrame
	 */	
	_preparePlayer() {
		// Check if exist
		if (this.dom.popin.querySelector('.plyr') != null) {
			this.Player = null;
			this.dom.popin.querySelector('.plyr').parentNode.removeChild(this.dom.popin.querySelector('.plyr'));
		}
		
		// Prepare dom for Injected Player
		let domHtml5 = '<video class="js-player" poster="'+this._params.poster+'" playsinline controls> \
			<source src="'+this._params.id+'" type="video/mp4" /> \
		</video>';
		// let domExt = '<div class="js-player" data-plyr-provider="'+this._params.type+'" data-plyr-embed-id="'+this._params.id+'"></div>';

		// let src = ( this._params.type == 'youtube' ) ? 'https://www.youtube.com/embed/'+this._params.id+'?&amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1' : 'https://player.vimeo.com/video/'+this._params.id+'?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media' ;
		
		
		let domExt = `<div class="player js-player" data-plyr-provider="${this._params.type}" data-plyr-embed-id="${this._params.id}"></div>`;
		// let domExt = `<div class="js-player"><iframe src="${src}" allowfullscreen allowtransparency allow="autoplay"></iframe></div>`;
		this.dom.wrapper.insertAdjacentHTML('afterbegin', (this._params.type == 'internal') ? domHtml5 : domExt);
		this.dom.video = this.dom.popin.querySelector('.js-player');

		// Prepare Poster
		// this.dom.poster.style.backgroundImage = 'url('+this._params.poster+')';

		this._initPlayer();
		/* if( this._params.type != 'internal' ) {

			this.dom.iframe = this.dom.wrapper.querySelector('iframe');

			this.dom.iframe.addEventListener('load', () => {
				this._initPlayer();
			});
		} else {
			this._initPlayer();
		} */
	}

	/**
	 * Init Video Player
	 */	
	_initPlayer() {
		/* this.Player = new Plyr(this.dom.video, {
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
			autoplay: true,
			fullscreen: {
				iosNative: true
			},
			playsinline: true,
			youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
			vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false }
		}); */

		this.Player = new Plyr(this.dom.video, {
			controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
			youtube: { noCookie: false, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1, playsinline: 0 },
			vimeo: { byline: false, portrait: false, title: false, speed: true, transparent: false }
		});

		this._originWidth = 0;
		this._originHeight = 0;

		this.Player.on('ready', event => {
			this._playerReady();
			// console.log(event);
			// console.log(event.detail.plyr);
			// let embed = event.detail.plyr.embed;
			// embed.getVideoWidth().then( (value) => {
			// 	this._originWidth = value;
			// 	embed.getVideoHeight().then( (value) => {
			// 		this._originHeight = value;
			// 		let ratio = this._originWidth + ':' + this._originHeight;
			// 		console.log('SET RATIO WITHH :: ', ratio);
			// 		this.Player.ratio = ratio;
			// 		this._playerReady();
			// 	});
			// });
		});

		this.Player.on('playing', event => {
			if( this.firstPlay ) {
				TweenLite.to(this.dom.wrapper, 0.5, {autoAlpha: 1});
			}
			TweenLite.to(this.dom.poster, 0.5, {
				autoAlpha: 0,
				onStart: function() {
					if( this.firstPlay ) {
						this.firstPlay = false;

						let ratio = this.Player.ratio;
						if( ratio == '1:1' )
							this.dom.wrapper.classList.add('small');
						else
							this.dom.wrapper.classList.remove('small');
					}
				}.bind(this)
			});
		});

		this.Player.on('ended', event => {
			this._onEnded();
		});
	}

	/**
	 * Ready to play
	 */	
	_playerReady() {
		this._showAllUi();
		if (this._params.autoPlay == 'true'){
			this._playVideo();
			if( this.dom.buttonPlay )
				TweenLite.to(this.dom.buttonPlay, 0.5, {autoAlpha: 0});
		}
	}

	/**
	 * Video Methods
	 */	
	_playVideo() {
		this.firstPlay = true;
		const playPromise = this.Player.play();
		if (playPromise && playPromise.then) {
			playPromise.catch(elm => {
				if( this.firstPlay ) {
					TweenLite.to(this.dom.wrapper, 0.5, {autoAlpha: 1});
				}
				this.Player.toggleControls(true);
			})
		}
	}

	_onEnded() {
		this._showAllUi();

		if (this._params.autoClose == 'true') {
			this.callbackEnded();
		}
	}

	stopVideo() {
		if (typeof this.Player === "undefined")
			return;

		if( this.firstPlay ) {
			TweenLite.to(this.dom.wrapper, 0.5, {autoAlpha: 1});
		}
		
		this._showAllUi();
		this.Player.stop();
	}

	/**
	 * UI Switch Visibility
	 */	
	_showAllUi() {
		TweenLite.to(this.dom.poster, 0.5, {autoAlpha: 1});
		if( this.dom.buttonPlay )
			TweenLite.to(this.dom.buttonPlay, 0.5, {autoAlpha: 1});
	}

	_showPoster() {
		TweenLite.to(this.dom.poster, 0.5, {autoAlpha: 1});
	}
}



// WEBPACK FOOTER //
// src/js/helpers/videos-popin-manager.js